module.exports = __webpack_public_path__ + "img/img-30.321e8bdb.png";